import type { NavBadgeTone } from "@src/components/Navigation/BaseSideNav/NavBadge";
import {
  isTrialDeadlineAhead,
  isTrialEndingSoon,
  resolveTrialDeadline,
} from "@src/utils/trial-deadline";

export const getModuleTrialNavBadge = (
  trialEndAt: number
): { label: string; tone: NavBadgeTone } | undefined => {
  const deadline = resolveTrialDeadline(trialEndAt);

  if (!isTrialDeadlineAhead(deadline)) {
    return undefined;
  }
  if (!isTrialEndingSoon(deadline)) {
    return { label: "New offer", tone: "accent" };
  }
  return {
    label:
      deadline.state === "running"
        ? `${deadline.remainingDays}d left`
        : "Ends today",
    tone: "warning",
  };
};
